export default function Guideline() {
  return (
    <p className='text-lg text-center'>
      Only one <span className='font-bold text-red-500'>.html</span> or <span className='font-bold text-red-500'>.css</span> file can be uploaded.
    </p>
  );
}